import type { TFunction } from 'i18next';

/**
 * Kickoff strings from `formatKickoff` use an English `Today,` prefix when the
 * event is today. Translate that prefix with the legacy `Today` key.
 */
export function translateKickoffLabel(kickoff: string, t: TFunction): string {
  const todayPrefix = 'Today, ';
  if (kickoff.startsWith(todayPrefix)) {
    return `${t('Today', { defaultValue: 'Today' })}, ${kickoff.slice(todayPrefix.length)}`;
  }
  return kickoff;
}
